import { Document, Page, Image, View, StyleSheet, Font } from '@react-pdf/renderer'
import React, { FC } from 'react'

Font.register({
  family: 'myriad-pro',
  fonts: [
    {
      src: require('assets/fonts/myriad-pro-regular.woff'),
      fontWeight: 400
    },
    {
      src: require('assets/fonts/myriad-pro-bold.woff'),
      fontWeight: 700
    }
  ]
})

Font.registerHyphenationCallback(word => [word])

interface ScreenshotPdfProps {
  imageData: string
}

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 25,
    fontFamily: 'myriad-pro',
    fontSize: '12pt',
    lineHeight: 1.6,
    wordWrap: 'break-word',
    maxWidth: '100%'
  },
  screenshot: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain'
  }
})

const ScreenshotPdf: FC<ScreenshotPdfProps> = ({ imageData }) => {
  return (
    <Document>
      <Page size='LETTER' style={styles.page}>
        <Image src={imageData} style={styles.screenshot} />
      </Page>

      <Page size='LETTER' style={styles.page} />
    </Document>
  )
}

export default ScreenshotPdf
